import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import Header from "../components/Header";
import { ChevronDown, Lock } from "lucide-react";

const MembershipSignup = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    companyname: "",
    industryname: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const industries = ["Technology & SaaS", "Healthcare", "Finance", "Education", "Retail", "Manufacturing"];

  const companies = ["Google", "Microsoft", "Amazon", "Meta", "Apple", "Netflix"];

  const [agreetoConditions, setAgreetoConditions] = useState(false);
  const handleCheckboxChange = (e) => {
    setAgreetoConditions(e.target.checked);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!agreetoConditions) {
      setError("Please agree to Terms & Conditions");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const requestData = {
        name: formData.name, // Map correctly
        email: formData.email,
        password: formData.password,
        company_name: formData.companyname,
        sector_industry: formData.industryname,
      };

      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/user/signup`, requestData, {
        headers: { "Content-Type": "application/json" },
      });

      console.log("Signup Successful:", response.data);

      navigate("/login", {
        state: { successMessage: "Signup request submitted! Please wait for approval." },
      });
    } catch (error) {
      console.error("Signup Error:", error);
      setError(error.response?.data?.message || error.response?.data?.error || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* <Header /> */}
      <div id="wrapper">
        <section className="signup-section d-flex align-items-center py-5 py-md-0">
          <div className="container signup-container pt60px">
            <div className="row">
              <div className="col-md-6 text-white d-flex align-items-center pe-md-5">
                <div className="pe-md-5 text-center text-md-start w-100">
                  <h1 className="fw-bold mb-4">Join industry professionals and make an impact.</h1>
                  <p className="testwhite40 ft-18 lh-27 inter">Create your account to access surveys, share your insights, and earn rewards.</p>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-container mt-5 mt-md-0">
                  <h2 className="ft-28 fw-bold mb-1 textred">Create Your Account</h2>
                  <p className="color858c95 ft-14 lh-27 inter">Join our community today</p>

                  {error && <p className="text-danger">{error}</p>}

                  <form onSubmit={handleSubmit}>
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        placeholder=" "
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="name">Your Name</label>
                    </div>

                    <div className="form-group">
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        name="email"
                        placeholder=" "
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="email">Email Address</label>
                    </div>

                    {/*
                    <div className="form-group">
                      <input
                        type="companyname"
                        className="form-control"
                        id="companyname"
                        name="companyname"
                        placeholder=" "
                        value={formData.companyname}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="companyname">Company Name</label>
                    </div>


                    {/* <div className="form-group">
                      <input
                        type="industryname"
                        className="form-control"
                        id="industryname"
                        name="industryname"
                        placeholder=" "
                        value={formData.industryname}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="industryname">Industry</label>
                    </div> */}

                    <div className="form-group">
                      <select
                        className="form-control custom-select-arrow"
                        id="companyname"
                        name="companyname"
                        value={formData.companyname}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Company</option>

                        {companies.map((company) => (
                          <option key={company} value={company}>
                            {company}
                          </option>
                        ))}
                      </select>

                      <label htmlFor="companyname">Company Name</label>

                      <ChevronDown size={18} className="custom-select-icon" />
                    </div>

                    <div className="form-group">
                      <select
                        className="form-control textgray custom-select-arrow"
                        id="industryname"
                        name="industryname"
                        value={formData.industryname}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Industry</option>

                        {industries.map((industry) => (
                          <option key={industry} value={industry}>
                            {industry}
                          </option>
                        ))}
                      </select>

                      <label htmlFor="industryname" className="textgray">
                        Industry Name
                      </label>

                      <ChevronDown size={18} className="custom-select-icon" />
                    </div>

                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <span className="stay-signed-in checkbox-container d-flex gap-3 ft-12">
                        <input id="persistent" name="persistent" type="checkbox" checked={agreetoConditions} onChange={handleCheckboxChange} />
                        <label for="persistent">
                          I agree to the{" "}
                          <Link to="/TermsAndConditions" className="login-link pr-2 textred" style={{ textDecoration: "none" }}>
                            Terms & Conditions
                          </Link>
                          <span className="px-1">and</span>
                          <Link to="/privacy-policy" className="login-link pl-2 textred" style={{ textDecoration: "none" }}>
                            Privacy Policy.
                          </Link>
                          .
                        </label>
                      </span>
                    </div>

                    <button type="submit" className="btn btn-red ft-15 fw-600 w-100 my-4 py-3" disabled={loading || !agreetoConditions}>
                      {loading ? "Submitting..." : "Submit"} <i className="fa-solid fa-arrow-right ms-2"></i>
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default MembershipSignup;
